import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../_metronic/_partials/controls";


export function ReceiptsLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.receipts.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
